import React from 'react';
import { KeycloakProvider, useKeycloak } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import { addConfig } from '../../actions/ConfigActions';
import store from '../../store/store';
import { Loading } from './Common/Loading';
import App from './App';

const AuthenticatedGlobalLayout = () => {
  const [keycloak, initialized] = useKeycloak();
  if (!initialized) {
    return <Loading />;
  }
  if (!keycloak.authenticated) {
    keycloak.login();
    return <Loading />;
  }

  // configure auth header
  store.dispatch(addConfig({ authorizationHeader: `Bearer ${keycloak.token}` }));

  return <App />;
};

// Configuring Keycloak user
const AppWithKeycloak = ({ appConfig }) => {
  const { KEYCLOAK_REALM, KEYCLOAK_URL, KEYCLOAK_CLIENT_ID, OPEN_ID_CONNECT } = appConfig;

  const oidcConfig = (OPEN_ID_CONNECT && Object.keys(OPEN_ID_CONNECT))
    ? {
      realm: OPEN_ID_CONNECT.REALM,
      url: OPEN_ID_CONNECT.AUTH_URL,
      clientId: OPEN_ID_CONNECT.CLIENT_ID,
    }
    : {
      realm: KEYCLOAK_REALM,
      url: KEYCLOAK_URL,
      clientId: KEYCLOAK_CLIENT_ID,
    };

  const keycloakInstance = new Keycloak(oidcConfig);

  const keycloakProviderInitConfig = {
    onLoad: 'check-sso',
    checkLoginIframe: false,
    promiseType: 'native',
  };

  return (
    <KeycloakProvider keycloak={keycloakInstance} initConfig={keycloakProviderInitConfig}>
      <AuthenticatedGlobalLayout />
    </KeycloakProvider>
  );
};

export default AppWithKeycloak;